import { TContentHubButton, StringField } from '../../../types/types';
import { TSummarySpecUpdated, TContentHubSeriesDetailHeroSectionFields } from '../types/productSeriesDetailHeroSection.types';
import { THeroSectionTextProps } from '../types/heroSectionText.types';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendRootToInternalLink } from '../../../utils/appendRootToInternalLink.utils';

export class HeroSectionTextModel {
  private readonly fields?: TContentHubSeriesDetailHeroSectionFields;

  constructor(props: THeroSectionTextProps) {
    this.fields = props?.fields || null;
  }

  get eyebrow(): StringField {
    return { value: this.fields?.apiData?.eyebrow };
  }

  get title(): StringField {
    return { value: this.fields?.apiData?.title };
  }

  get description(): StringField {
    return {
      value: appendRootToRichTextInternalLinks(this.fields?.apiData?.description),
    };
  }

  get primaryLink(): TContentHubButton | undefined {
    return this.fields?.apiData?.button1;
  }

  get primaryCTAUrl(): string | undefined {
    return appendRootToInternalLink(this?.primaryLink?.url);
  }

  get secondaryLink(): TContentHubButton | undefined {
    return this.fields?.apiData?.button2;
  }

  get secondaryCTAUrl(): string | undefined {
    return appendRootToInternalLink(this?.secondaryLink?.url);
  }

  get isPrimaryOrSecondaryCTAExists(): boolean {
    return !!((this.primaryLink?.url && this.primaryLink?.label) || (this.secondaryLink?.url && this.secondaryLink?.label));
  }

  get summarySpecs(): Array<TSummarySpecUpdated> {
    return (
      this.fields?.apiData?.summarySpecs
        ?.filter((spec) => spec.active)
        .map((spec) => {
          return { key: { value: spec.key }, value: { value: spec.value } };
        }) || []
    );
  }

  get optionalLabel(): StringField {
    return { value: this.fields?.apiData?.optionalLabel };
  }

  get msrp(): StringField {
    return { value: this.fields?.apiData?.msrp ? '&dollar;' + this.fields?.apiData?.msrp : '' };
  }

  get showInfoTooltip(): boolean {
    return !!(this.fields?.apiData?.msrpTitle || this.fields?.apiData?.msrpDescription);
  }

  get infoTooltipTitle(): StringField {
    return { value: this.fields?.apiData?.msrpTitle };
  }

  get infoTooltipDescription(): StringField {
    return { value: this.fields?.apiData?.msrpDescription };
  }
}
